import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const getleadConvertChartDataAsync = createAsyncThunk(
  "mis/getleadConvertChartData",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/mis/get-lead-pie-chart-data`,
      payload,
      toolkit
    );
  }
);
